<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Payment.Whitelist.Credit.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="sUsername">Username </label>
              <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <label class="mr-sm-2" for="sStartDate">Start Date </label>
              <b-input id="sStartDate" type="date" placeholder="" v-model.trim="sStartDate"></b-input>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <label class="mr-sm-2" for="sEndDate">End Date </label>
              <b-input id="sEndDate" type="date" placeholder="" v-model.trim="sEndDate"></b-input>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="queryEarlyCashback"><i class="fa fa-search"></i> Search</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-inr'></i> Early Cashback List</h3>
              <div class="float-right">
                <b-button variant="primary" @click="exportEarlyCashback">Export</b-button>&nbsp;&nbsp;&nbsp;&nbsp;
                <b-button variant="primary" class="float-right" @click="showManagementModal">Add Early Cashback</b-button>
              </div>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(sn)="data">
                {{data.index+1 + ((currentPage-1)*perPage)}}
              </template>
              <template v-slot:cell(CashbackFrom)="data">
                {{ data.item.CashbackFrom }} - {{ data.item.CashbackTo }}
              </template>
              <template v-slot:cell(CashbackAmount)="data">
                <span>{{format(data.item.CashbackAmount, '0,0.00')}}</span>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="showManagementModal" size="lg" header-bg-variant="primary" hide-footer title="Add Early Cashback">
      <div class="d-block">
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="12">
                <b-form-group :state="!$v.searchName.$error">
                  <b-input-group>
                    <b-form-input type="text" placeholder="Enter Username for Search" v-model.trim="searchName" :state="$v.searchName.$error?false:null" @focus.native="$v.searchName.$touch"></b-form-input>
                    <b-input-group-button class="input-group-append">
                      <b-btn variant="success" @click="searchMember" :disabled="$v.searchName.$invalid">
                        <i class="fa fa-search"></i> Search
                      </b-btn>
                    </b-input-group-button>
                  </b-input-group>
                  <div v-if="$v.searchName.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.searchName.required">Username is required</div>
                    <div class="invalid-feedback d-block" v-else-if="!$v.searchName.minLength">Must have at least {{ $v.searchName.$params.minLength.min}} letters</div>
                    <div class="invalid-feedback d-block" v-else-if="!$v.searchName.maxLength">Must no exceed {{ $v.searchName.$params.maxLength.max}} letters</div>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="members" :fields="memberFields" :current-page="memberCurrentPage" :per-page="memberPerPage">
                  <template v-slot:cell(action)="data">
                    <b-button variant="success" @click="showAddCashbackModal(data.item)">Add Cashback</b-button>
                  </template>
                </b-table>
                <nav>
                  <b-pagination :total-rows="getMemberRowCount(members)" :per-page="memberPerPage" v-model="memberCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-btn class="mt-3" variant="outline-danger" @click="hideManagementModal">Cancel</b-btn>
    </b-modal>

    <b-modal ref="showAddCashbackModal" v-model="showAddCashback" size="lg" header-bg-variant="primary" hide-footer @hide="hideAddCashbackModal" title="Add Early Cashback">
      <div class="d-block">
        <b-row>
          <b-col sm="6">
            <label for="cUsername">Username</label><br/>
            <b-form-input id="cUsername" type="text" v-model.trim="form.username" readonly></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.username.required">Username is required</div>
          </b-col>
          <b-col sm="6">
            <label for="cAmount">Cashback Amount</label><br/>
            <b-form-input id="cAmount" type="text" v-model.trim="form.amount"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.amount.required">Amount is required</div>
          </b-col>
          <br><br><br><br>
          <b-col sm="6">
            <label for="cFrom">Cashback From</label><br/>
            <b-form-input id="cFrom" type="date" v-model.trim="form.startDate"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.startDate.required">Select Cashback From Date</div>
          </b-col>
          <b-col sm="6">
            <label for="cTo">Cashback To</label><br/>
            <b-form-input id="cTo" type="date" v-model.trim="form.endDate"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.endDate.required">Select Cashback To Date</div>
          </b-col>
          <br><br><br><br>
          <b-col sm="12">
            <label for="cMemo">Memo</label><br/>
            <b-form-input id="cMemo" type="text" v-model.trim="form.memo"></b-form-input>
          </b-col>
          <br><br><br><br>
          <b-col sm="12">
            <b-button variant="success" @click="addCashback()">Add Cashback</b-button>
            <b-button variant="danger" @click="hideAddCashbackModal()">Cancel</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../../events.js'
  import numeral from 'numeral'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  let moment = require('moment-timezone')

  export default {
    name: 'whitelist-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        showAddCashback: false,
        items: [],
        members: [],
        fields: [
          {key: 'sn', label: 'S.No'},
          {key: 'Username', label: 'Username'},
          {key: 'CashbackFrom', label: 'Cashback From - To'},
          {key: 'CashbackAmount', label: 'Cashback Amount'},
          {key: 'Operator', label: 'Add By'},
          {key: 'UpdateTime', label: 'AddTime'}
        ],
        memberFields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        memberCurrentPage: 1,
        perPage: 30,
        memberPerPage: 10,
        totalMemberRows: 0,
        operator: '',
        searchName: '',
        sUsername: '',
        sStartDate: '',
        sEndDate: '',
        form: {
          memberId: '',
          username: '',
          startDate: '',
          endDate: '',
          amount: '',
          memo: ''
        }
      }
    },
    validations: {
      searchName: { required, minLength: minLength(5), maxLength: maxLength(20) },
      form: {
        username: { required },
        startDate: { required },
        endDate: { required },
        amount: { required }
      }
    },
    methods: {
      format (num, fmt) {
        return numeral(num).format(fmt)
      },
      getRowCount (items) {
        return items.length
      },
      getMemberRowCount (members) {
        return members.length
      },
      async queryEarlyCashback () {
        if (this.sUsername !== '' || this.sStartDate !== '' || this.sEndDate !== '') {
          this.searchEarlyCashback()
        } else {
          this.getEarlyCashback()
        }
      },
      async searchEarlyCashback () {
        try {
          let username = this.sUsername
          let sDate = this.sStartDate
          let eDate = this.sEndDate
          let query = `/payment/earlyCashback/search?username=${username}&startDate=${sDate}&endDate=${eDate}`
          let result = await this.$http.get(this.API_ENDPOINT + query, { headers: { 'Content-Type': 'application/json' } })
          this.items = result.data.result
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async getEarlyCashback () {
        try {
          let result = await this.$http.get(this.API_ENDPOINT + '/payment/earlyCashback/getAll', { headers: { 'Content-Type': 'application/json' } })
          this.items = result.data.result
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      searchMember () {
        this.$http.post(this.API_ENDPOINT + '/member/search', {searchName: this.searchName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.members = response.data.members
          this.totalMemberRows = response.data.members.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      showManagementModal () {
        this.$refs.showManagementModal.show()
      },
      hideManagementModal () {
        this.$refs.showManagementModal.hide()
      },
      showAddCashbackModal (item) {
        this.form.memberId = item.Id
        this.form.username = item.Username
        this.showAddCashback = true
      },
      hideAddCashbackModal () {
        this.form.memberId = ''
        this.form.username = ''
        this.showAddCashback = false
        this.queryEarlyCashback()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      },
      async exportEarlyCashback () {
        if (this.sUsername !== '' || this.sStartDate !== '' || this.sEndDate !== '') {
          this.searchEarlyCashbackCSV()
        } else {
          this.getEarlyCashbackCSV()
        }
      },
      async getEarlyCashbackCSV () {
        try {
          let response = await this.$http.get(this.API_ENDPOINT + '/payment/earlyCashback/getAll/export', { responseType: 'blob', headers: { 'Content-Type': 'application/json' } })
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `early_cashback_report_${moment().format('YYYYMMDD')}.csv`)
          document.body.appendChild(link)
          link.click()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async searchEarlyCashbackCSV () {
        try {
          let username = this.sUsername
          let sDate = this.sStartDate
          let eDate = this.sEndDate
          let query = `/payment/earlyCashback/search/export?username=${username}&startDate=${sDate}&endDate=${eDate}`
          let result = await this.$http.get(this.API_ENDPOINT + query, { headers: { 'Content-Type': 'application/json' } })
          const url = window.URL.createObjectURL(new Blob([ result.data ]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `early_cashback_report_${moment().format('YYYYMMDD')}.csv`)
          document.body.appendChild(link)
          link.click()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async addCashback () {
        try {
          let data = {
            memberId: this.form.memberId,
            username: this.form.username,
            from: this.form.startDate,
            to: this.form.endDate,
            amount: this.form.amount,
            memo: this.form.memo
          }
          this.$v.form.$touch()
          if (this.$v.form.$error) {
            return true
          } else {
            await this.$http.post(this.API_ENDPOINT + '/payment/earlyCashback/add', data, { headers: { 'Content-Type': 'application/json' } })
            this.hideAddCashbackModal()
          }
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      }
    },
    created () {
      this.getEarlyCashback()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/earlyCashback/EarlyCashbackTable.vue